module.exports = __webpack_public_path__ + "media/images/NewBMP@2x-5b4ea3d3df0b99fca4a353efe257719f.png";